import { MouseEvent, ReactElement } from 'react';
import { useSelectable } from 'b2b-components/hooks/useSelectable';
import { useTranslate } from 'b2b-apps/core/i18n/hooks';
import { useUrlCreator } from 'b2b-apps/core/routes/hooks';
import { NavigationItemType } from 'b2b-common/core/catalog/Catalog.types';
import { Categories } from './Categories';
import { Props } from './CategoriesContainer.types';

export const CategoriesContainer = ({ categories, isLevelZeroAvailable, onChange }: Props): ReactElement => {
  const t = useTranslate();
  const urlCreator = useUrlCreator();
  const { isOptionChecked } = useSelectable();

  const goToCategory = (e: MouseEvent<HTMLElement>, category: string, label: string): void => {
    e.preventDefault();
    onChange(category, label);
  };

  const getParentCategory = (): NavigationItemType | null => {
    const { selected } = categories;
    let parent = null;

    if (selected.length > 1) {
      parent = selected.slice(-2, -1).pop();
    } else if (selected.length === 1 && isLevelZeroAvailable) {
      parent = {
        name: t('All Categories'),
        field: '',
        checked: false,
        count: 0,
        url: '',
      };
    }

    return parent || null;
  };

  const getCurrentCategory = (): NavigationItemType | null => {
    const { selected } = categories;

    return selected.slice(-1).pop() || null;
  };

  return (
    <Categories
      categories={categories}
      getCurrentCategory={getCurrentCategory}
      getParentCategory={getParentCategory}
      goToCategory={goToCategory}
      isOptionChecked={isOptionChecked}
      urlCreator={urlCreator}
    />
  );
};
